import axios from "axios";

const backendUrl =
  process.env.REACT_APP_BACKEND_URL ||
  "http://localhost:8000";

const cleanBackendUrl =
  backendUrl.replace(/\/+$/, "");

export const api = axios.create({
  baseURL: `${cleanBackendUrl}/api`,
  withCredentials: true,
  timeout: 30000,
});


api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("fh_token");

    if (token) {
      config.headers.Authorization =
        `Bearer ${token}`;
    }

    return config;
  },

  (error) =>
    Promise.reject(error)
);


api.interceptors.response.use(
  (response) => response,

  (error) => {
    const status =
      error.response?.status;

    const detail =
      error.response?.data?.detail;

    const code =
      detail &&
      typeof detail === "object"
        ? detail.code
        : null;


    // -------------------------------------------------------
    // Authentication failure
    // -------------------------------------------------------

    if (status === 401) {
      localStorage.removeItem(
        "fh_token"
      );

      return Promise.reject(
        error
      );
    }


    // -------------------------------------------------------
    // Subscription access failure
    // -------------------------------------------------------

    if (
      status === 403 &&
      code === "subscription_required"
    ) {
      const currentPath =
        window.location.pathname;

      const alreadyOnBilling =
        currentPath ===
          "/app/billing" ||
        currentPath.startsWith(
          "/app/billing/"
        );

      if (!alreadyOnBilling) {
        sessionStorage.setItem(
          "fh_subscription_message",
          detail?.message ||
            "An active Farm Hand subscription is required."
        );

        window.location.assign(
          "/app/billing?access=subscription_required"
        );
      }

      return Promise.reject(
        error
      );
    }


    // -------------------------------------------------------
    // Pro-plan requirement
    // -------------------------------------------------------

    if (
      status === 403 &&
      code === "pro_required"
    ) {
      const currentPath =
        window.location.pathname;

      const alreadyOnBilling =
        currentPath ===
          "/app/billing" ||
        currentPath.startsWith(
          "/app/billing/"
        );

      if (!alreadyOnBilling) {
        sessionStorage.setItem(
          "fh_subscription_message",
          detail?.message ||
            "Farm Hand Pro or Consultant is required."
        );

        window.location.assign(
          "/app/billing?access=pro_required"
        );
      }

      return Promise.reject(
        error
      );
    }


    // -------------------------------------------------------
    // Consultant-only requirement
    // -------------------------------------------------------

    if (
      status === 403 &&
      code === "consultant_required"
    ) {
      const currentPath =
        window.location.pathname;

      const alreadyOnBilling =
        currentPath ===
          "/app/billing" ||
        currentPath.startsWith(
          "/app/billing/"
        );

      if (!alreadyOnBilling) {
        sessionStorage.setItem(
          "fh_subscription_message",
          detail?.message ||
            "Farm Hand Consultant is required."
        );

        window.location.assign(
          "/app/billing?access=consultant_required"
        );
      }

      return Promise.reject(
        error
      );
    }


    // -------------------------------------------------------
    // Pro farm-count limit
    // -------------------------------------------------------

    if (
      status === 403 &&
      code === "pro_farm_limit"
    ) {
      sessionStorage.setItem(
        "fh_subscription_message",
        detail?.message ||
          "Farm Hand Pro supports one farm."
      );

      return Promise.reject(
        error
      );
    }


    return Promise.reject(
      error
    );
  }
);


export function formatApiErrorDetail(
  detail
) {
  if (detail == null) {
    return (
      "Something went wrong. " +
      "Please try again."
    );
  }

  if (
    typeof detail === "string"
  ) {
    return detail;
  }

  if (
    Array.isArray(detail)
  ) {
    return detail
      .map((entry) => {
        if (
          entry &&
          typeof entry.msg ===
            "string"
        ) {
          return entry.msg;
        }

        return JSON.stringify(
          entry
        );
      })
      .filter(Boolean)
      .join(" ");
  }

  if (
    detail &&
    typeof detail.message ===
      "string"
  ) {
    return detail.message;
  }

  if (
    detail &&
    typeof detail.msg ===
      "string"
  ) {
    return detail.msg;
  }

  try {
    return JSON.stringify(
      detail
    );
  } catch {
    return String(
      detail
    );
  }
}


export default api;